import { createColumnHelper } from '@tanstack/react-table';

import { FilterType, Transaction } from '../_openapi/portfolio-optimizer';
import { dateCol, moneyCol, numberCol, textCol } from '../widgets/Table/columnHelpers/colDef';

const columnHelper = createColumnHelper<Transaction>();
export const transactionsListColumns = [
    columnHelper.accessor('tradeDate', dateCol({ id: 'tradeDate', header: 'Date' })),
    columnHelper.accessor('householdName', textCol({ id: 'householdName' })),
    columnHelper.accessor('portfolioName', textCol({ id: 'portfolioName' })),
    columnHelper.accessor('pId', textCol({ id: 'pId' })),
    columnHelper.accessor('aC', textCol({ id: 'aC' })),
    columnHelper.accessor('portfolioGuid', textCol({ id: 'portfolioGuid' })),
    columnHelper.accessor(
        'type',
        textCol({
            id: 'type',
            meta: {
                filterOptionsFn: () => [
                    'Transfer In',
                    'Withdrawals',
                    'Coupons & Interest',
                    'Transfer Out',
                    'Dividends',
                    'Deposits',
                    'Fees & Charges',
                ],
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor('subType', textCol({ id: 'subType' })),
    columnHelper.accessor('symbol', textCol({ id: 'symbol' })),
    columnHelper.accessor('assetDisplayName', textCol({ id: 'assetDisplayName' })),
    columnHelper.accessor('quantity', numberCol({ id: 'quantity' })),
    columnHelper.accessor('closePrice', moneyCol({ id: 'closePrice' })),
    columnHelper.accessor('amount', numberCol({ id: 'amount' })),
    columnHelper.accessor('cusip', textCol({ id: 'cusip' })),
    columnHelper.accessor('isin', textCol({ id: 'isin' })),
    columnHelper.accessor('transferAccount', textCol({ id: 'transferAccount' })),
    columnHelper.accessor('transactionId', textCol({ id: 'transactionId' })),
    columnHelper.accessor('transactionDetail', { ...textCol({ id: 'transactionDetail' }), size: 500 }),
    columnHelper.accessor('currencyPrimary', textCol({ id: 'currencyPrimary' })),
];
